/* eslint-disable @typescript-eslint/no-explicit-any */
import { TextProps, Box, VStack, Image } from '@chakra-ui/react';
import { Text } from '../../../components/atoms/Text';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { CarouselConteiner } from '../../../components/molecules/Carousel';

export function Label(props: TextProps) {
  return <Text color="#000000" fontFamily={'Glory'} fontWeight={'400'} fontSize={14} {...props} />;
}

const CarouselItem = ({ desc, image }: { desc: string; image?: string }) => {
  return (
    <VStack width={'100%'} align={'center'} spacing={4}>
      <Text fontSize={16} width={'100%'} fontFamily={'Glory'} fontWeight={'500'} textAlign={'center'}>
        {desc}
      </Text>
      {image && (
        <Box>
          <Image height={500} width={'100%'} src={image} alt={desc} />
        </Box>
      )}
    </VStack>
  );
};

const cinemark = [
  {
    desc: '1. Clicar em "usar desconto":',
    image: '/assets/cinemas/cinemark/step1.png',
  },
  {
    desc: '2. Assinalar o "de Acordo":',
    image: '/assets/cinemas/cinemark/step2.png',
  },
  {
    desc: '3. Efetue o pagamento com seu cartão de crédito:',
    image: '/assets/cinemas/cinemark/step3.png',
  },
  {
    desc: '4. Entre em cinemark.com.br, escolha a unidade, o filme desejado, o assento e clique em "escolher tipo de ingresso":',
    image: '/assets/cinemas/cinemark/step4.png',
  },
  {
    desc: '5. Na página para escolher seus ingressos, clique em "voucher", insira o(s) código(s), de 9 digitos, recebido(s) por email e ele será trocado pelo seu ingresso:. Clicar em "usar desconto":',
    image: '/assets/cinemas/cinemark/step5.png',
  },
  {
    desc: '6. Abra o app Cinemark, clique em "pedidos" e seu ingresso estará lá:',
    image: '/assets/cinemas/cinemark/step6.png',
  },
];

const cinepolis = [
  {
    desc: '1. Clicar em "usar desconto":',
    image: '/assets/cinemas/cinepolis/step1.png',
  },
  {
    desc: '2. Assinalar o "de Acordo":',
    image: '/assets/cinemas/cinepolis/step2.png',
  },
  {
    desc: '3. Efetue o pagamento com seu cartão de crédito:',
    image: '/assets/cinemas/cinepolis/step3.png',
  },
  {
    desc: '4. O(s) código(s) recebido(s), de 16 digitos, por email deve ser trocado(s) pelo(s) ingresso(s) apenas nas bilheterias dos cinemas Cinépolis.',
    //image: '/assets/cinemas/cinepolis/step4.png',
  },
];

const cinesystem = [
  {
    desc: '1. Clicar em "usar desconto":',
    image: '/assets/cinemas/cinesystem/step1.png',
  },
  {
    desc: '2. Assinalar o "de Acordo":',
    image: '/assets/cinemas/cinesystem/step2.png',
  },
  {
    desc: '3. Efetue o pagamento com seu cartão de crédito:',
    image: '/assets/cinemas/cinesystem/step3.png',
  },
  {
    desc: '4. Entre em cinesystem.com.br, escolha a unidade, o filme desejado, o assento e clique em "escolher tipo de ingressos":.',
    image: '/assets/cinemas/cinesystem/step4.png',
  },
  {
    desc: '5. Na página para escolher seus ingressos, clique em "cinesystem pass", insira o(s) código(s), de 9 digitos, recebido(s) por email e ele será trocado pelo seu ingresso:',
    image: '/assets/cinemas/cinesystem/step5.png',
  },
];

const KINOPLEX = [
  {
    desc: '1. Clicar em "usar desconto":',
    image: '/assets/cinemas/kinoplex/step1.png',
  },
  {
    desc: '2. Assinalar o "de Acordo":',
    image: '/assets/cinemas/kinoplex/step2.png',
  },
  {
    desc: '3. Efetue o pagamento com seu cartão de crédito:',
    image: '/assets/cinemas/kinoplex/step3.png',
  },
  {
    desc: '4. Entre em kinoplex.com.br, escolha a unidade, o filme desejado, o assento e clique em "escolher tipo de ingressos"',
    image: '/assets/cinemas/kinoplex/step4.png',
  },
  {
    desc: '5 Na página para escolher seus ingressos, clique em "cineticket", insira o(s) código(s), de 9 digitos, recebido(s) por email e ele será trocado pelo seu ingresso:',
    image: '/assets/cinemas/kinoplex/step5.png',
  },
];

const uci = [
  {
    desc: '1. Clicar em "usar desconto":',
    image: '/assets/cinemas/uci/step1.png',
  },
  {
    desc: '2. Assinalar o "de Acordo":',
    image: '/assets/cinemas/uci/step2.png',
  },
  {
    desc: '3. Efetue o pagamento com seu cartão de crédito:',
    image: '/assets/cinemas/uci/step3.png',
  },
  {
    desc: '4.O(s) código(s) recebido(s), de 22 digitos, por email deve ser trocado pelo(s) ingresso(s) apenas nas bilheterias dos cinemas UCI.',
    //image: '/assets/cinemas/uci/step4.png',
  },
];

export function HowToUse({ name }: { name?: string }) {
  if (name && ['cinemark', 'cinépolis', 'cinesystem', 'kinoplex', 'uci cinemas'].includes(name.toLocaleLowerCase())) {
    return (
      <Box display={'flex'} flexDir={'column'} width={'100%'}>
        <VStack align={'center'} spacing={4} width={'100%'}>
          <Text fontSize={20} fontFamily={'Glory'} fontWeight={'bold'} textAlign={'center'}>
            Como usar seu ingresso
          </Text>
          <VStack align={'center'} justifyContent={'center'} width={'100%'} spacing={4}>
            {name?.toLowerCase() === 'CINEMARK'.toLowerCase() && (
              <CarouselConteiner
                banners={cinemark}
                renderItem={(step) => <CarouselItem desc={step.desc} image={step.image} />}
              />
            )}
            {name?.toLowerCase() === 'Cinépolis'.toLowerCase() && (
              <CarouselConteiner
                banners={cinepolis}
                renderItem={(step) => <CarouselItem desc={step.desc} image={step.image} />}
              />
            )}
            {name?.toLowerCase() === 'CINESYSTEM'.toLowerCase() && (
              <CarouselConteiner
                banners={cinesystem}
                renderItem={(step) => <CarouselItem desc={step.desc} image={step.image} />}
              />
            )}
            {name?.toLowerCase() === 'KINOPLEX'.toLowerCase() && (
              <CarouselConteiner
                banners={KINOPLEX}
                renderItem={(step) => <CarouselItem desc={step.desc} image={step.image} />}
              />
            )}
            {name?.toLowerCase() === 'UCI Cinemas'.toLowerCase() && (
              <CarouselConteiner
                banners={uci}
                renderItem={(step) => <CarouselItem desc={step.desc} image={step.image} />}
              />
            )}
          </VStack>
        </VStack>
      </Box>
    );
  }
  return null;
}
